"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowPublishServiceMessage = void 0;
const show_publish_1 = require("./show-publish");
/**
 * Union of any messages produced to or consumed from the Event Bus by
 * `@backstage-services/site-publish`.
 */
exports.ShowPublishServiceMessage = show_publish_1.ShowVersionMessage;
